import { env } from 'utils/env';

const staticUrl = env('REACT_APP_STATIC_URL');

const carrosselImages = [
  {
    id: 1,
    title: 'Excursões Banner 1',
    description: 'Descrição do banner 1',
    image: `${staticUrl}/images/Excursoes/Carrossel/excursoes_carrossel_banner_1.png`,
    link: '#',
  },
  {
    id: 2,
    title: 'Excursões Banner 2',
    description: 'Descrição do banner 2',
    image: `${staticUrl}/images/Excursoes/Carrossel/excursoes_carrossel_banner_2.png`,
    link: '#',
  },
];

export default carrosselImages;
